import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./LogoutMessage.css"; // Reuse the existing CSS

const UniversalLogoutMessage = ({ setIsLoggedIn }) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // Redirect to the home page after 2 seconds
    const timeoutId = setTimeout(() => {
      // Push the home route to navigate to it
      history.push("/home");
      // Set isLoggedIn to false after redirecting
      setIsLoggedIn(false);
      // Clear all items from local storage
      localStorage.clear();
      
      // Optional: Log the logout for debugging
      console.log("Universal logout completed - localStorage cleared, redirecting to home");
    }, 2000);

    // Clean up the timeout when the component unmounts
    return () => {
      clearTimeout(timeoutId);
    };
  }, [history, setIsLoggedIn]);

  // Check if this is coming from account deletion
  const isFromAccountDeletion = new URLSearchParams(location.search).get('from') === 'account-deletion';

  return (
    <div className="message-container">
      <h1>
        {isFromAccountDeletion 
          ? "Redirecting you to the home page..."
          : "You have logged out successfully! Redirecting you to the home page..."
        }
      </h1>
      
    </div>
  );
};

export default UniversalLogoutMessage;
